import { url } from "./apiSetup";
import { phpRequest } from "./phpRequest";

export const downloadTemplateAPI = async (company_id) => {
  const queryParams = {
    company_id: company_id,
  };
  const data = await phpRequest.get(
    "/devices/template-excel-download",
    queryParams
  );
  const fileUrl = data.url;
  const link = document.createElement("a");
  link.href = `${url}/${fileUrl}`;
  link.download = "templates.zip";
  link.click();
};
